var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"general_section"},[_c('Colors'),_c('Sizes')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }